<template>
  <div class="jura-start">
    <div class="jura-teaser">
      <div class="text">
        <span class="jahre">Über 10 Jahre</span>
        <span class="maler">Maler Jura</span>
        <span class="heusweiler">Heusweiler</span>
      </div>
    </div>
    <b-container fluid>
        <b-row class="section">
            <b-col lg="5" class="image left" order="2" order-lg="1"></b-col>
            <b-col lg="7" class="text-maler" order="1" order-lg="2">
              <h2>Malermeister Jura</h2>
              <p>Wir sind ein junger aufstrebender Malerfachbetrieb.<br>
              Gegründet am 26. Januar 2007 in Heusweiler.<br><br>
              Richard-Wagner-Straße 13, 66265 Heusweiler<br>
              Telefon: 06806 931115<br>
              Mobil: 0176 20303939<br>
              Email: <a href="mailto:info@maler-jura.de">info@maler-jura.de</a></p>
            </b-col>
        </b-row>
        <b-row class="section">
            <b-col lg="5" offset-lg="2" class="text-Handwerk">
              <h2>Unser Handwerk</h2>
              <p>Tapezierarbeiten<br>
              Kreative Wandgestaltung<br>
              Putzarbeiten<br>
              Wärmedämmverbundsysteme<br>
              Lackierarbeiten<br>
              Bodenbelagsarbeiten</p>
              <b-button :variant="'outline-success'" to="/handwerk">
                  Beispiele
              </b-button>
            </b-col>
            <b-col lg="5" class="image right"></b-col>
        </b-row>
        <b-row class="section beratung">
            <b-col sm="2" offset-lg="4" class="text-right ruediger">
              <b-img fluid src="~@/assets/img/ruediger.jpg" alt="Maler Rüdiger"></b-img>
            </b-col>
            <b-col sm="3">
              <h2>Kostenlose Beratung</h2>
              <b-img fluid src="~@/assets/img/telefon.jpg" alt="Maler Telefonnummer"></b-img>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.jura-start {
  .jura-teaser {
    background-image: url('../assets/img/pexels-photo-8724.jpg');
    background-position: center;
    background-size: cover;

    height: 500px;

    .text {
      background-color: rgba(255, 255, 255, 0.5);
      font-family: LatoWebLight;
      color: #497EAF;
      padding: 10px;
      margin-left: 20px;
      width: 500px;
      position: relative;
      top: 220px;

      span {
        display: block;
        line-height: 1;
      }

      .jahre {
        font-size: 30px;
      }

      .maler {
        font-size: 72px;
      }

      .heusweiler {
        font-size: 96px;
      }
    }
  }

  .section {
    height: 400px;
    margin-top: 80px;

    h2 {
      font-family: LatoWebMedium;
      font-size: 64px;
      line-height: 1;
    }

    .image {
      height: 400px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      &.left {
        background-image: url('~@/assets/img/auto.jpg');
      }

      &.right {
        background-image: url('~@/assets/img/art-wall-brush-painting.jpg');
      }
    }

    .text-maler {
      padding: 60px 0 0 100px;
    }

    .text-Handwerk {
      padding: 60px 0 0 0;
    }

    &.beratung {
      h2 {
        margin-bottom: 30px;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .jura-start {
    .section {
      height: auto;
      margin-top: 40px;

      h2 {
        font-size: 64px;
        line-height: 1;
      }

      .image {
        height: 400px;
      }

      .text-maler {
        padding: 40px 0 0 20px;
      }

      .text-Handwerk {
        padding: 40px 0 0 20px;
      }

      &.beratung {
        padding: 0 0 40px 20px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .jura-start {
    .section {
      height: auto;
      margin-top: 0;
      padding: 20px 0;

      .text-maler {
        padding: 0 0 20px 20px;
      }

      .text-Handwerk {
        padding: 0 0 20px 20px;
      }
    }
  }
}

@media screen and (max-width: 560px) {
  .jura-start {
    .jura-teaser {

      height: 300px;

      .text {
        margin: 0;
        width: 100%;
        top: 100px;

        .jahre {
          font-size: 24px;
        }

        .maler {
          font-size: 50px;
        }

        .heusweiler {
          font-size: 72px;
        }
      }
    }

    .section {
      h2 {
        font-size: 48px;
      }

      &.beratung {
        .ruediger {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .jura-start {
    .jura-teaser {

      height: 250px;

      .text {
        margin: 0;
        width: 100%;
        top: 100px;

        .jahre {
          font-size: 18px;
        }

        .maler {
          font-size: 30px;
        }

        .heusweiler {
          font-size: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Start.vue